export default {
  title: 'AI Agent Assistant',
  cta: {
    tryFree: 'Try for Free',
    startNow: 'Start Now',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
    contactUs: 'Contact Us'
  },
  hero: {
    title: 'Intelligent',
    highlight: 'AI Agent',
    subtitle: 'Make Your Work More Efficient',
    description: 'An intelligent assistant based on large language models, providing comprehensive work support to improve efficiency',
    cta: 'Get Started',
    learnMore: 'Learn More'
  },
  features: {
    title: 'Core Features',
    description: 'Powerful features to help you handle various work scenarios with ease',
    cards: {
      agent: {
        title: 'AI Agent',
        description: 'Intelligent agent system that can automatically complete various tasks according to your needs',
        action: 'View Details',
        features: {
          customizable: 'Fully Customizable',
          multilingual: 'Multi-language Support',
          scalable: 'Scalable Architecture'
        }
      },
      reasoning: {
        title: 'Intelligent Reasoning',
        description: 'Powerful reasoning capabilities to help you analyze complex problems and provide solutions',
        action: 'Learn More',
        features: {
          contextual: 'Context Understanding',
          accurate: 'Accurate Reasoning',
          efficient: 'Efficient Processing'
        }
      },
      tools: {
        title: 'Tool Integration',
        description: 'Rich tool integration to meet your various work needs',
        action: 'Explore Tools',
        features: {
          extensive: 'Rich Tool Library',
          flexible: 'Flexible Configuration',
          secure: 'Safe and Reliable'
        }
      }
    }
  },
  showcase: {
    title: 'Application Showcase',
    description: 'See how other users are using our product',
    cases: {
      coding: {
        title: 'Code Development',
        description: 'Intelligent programming assistant providing code suggestions and auto-completion',
        stats: 'Development Efficiency Improvement',
        performance: '75% Development Efficiency Boost',
        stats_title: {
          task: 'Task Type',
          tools: 'Tools Used',
          performance: 'Performance',
          efficiency: 'Efficiency Gain'
        },
        stats_value: {
          task: 'Code Development',
          tools: 'VSCode/Git/CLI',
          performance: 'Code Quality Optimization',
          efficiency: '75% Time Saved'
        }
      },
      analysis: {
        title: 'Data Analysis',
        description: 'Intelligent data analysis to quickly discover data value',
        stats: 'Data Analysis Efficiency',
        performance: 'Accuracy Increased to 95%',
        stats_detail: 'Significant improvement in data analysis efficiency with accuracy over 95%',
        metrics: {
          accuracy: 'Accuracy',
          speed: 'Processing Speed',
          insight: 'Insight Depth',
          value: 'Value Discovery'
        }
      },
      assistant: {
        title: 'Intelligent Assistant',
        description: '24/7 online intelligent assistant to answer your questions',
        stats: '80% Response Speed Improvement',
        performance: '80% Faster Response Time',
        stats_detail: '24/7 intelligent service with average response time under 3 seconds',
        messages: {
          user1: 'Hello, I need help',
          assistant1: "Hi! I'm your AI assistant, happy to help",
          user2: 'Can you help me analyze this data?',
          assistant2: 'Of course, let me help you analyze it in detail'
        }
      },
      automation: {
        title: 'Automation',
        description: 'Workflow automation to improve work efficiency',
        stats: '90% Automation Level Improvement',
        performance: '90% Increase in Automation',
        stats_detail: 'Significant improvement in process automation with 90% reduction in manual intervention',
        metrics: {
          efficiency: 'Efficiency Boost',
          accuracy: 'Accuracy',
          coverage: 'Coverage',
          reliability: 'Reliability'
        }
      }
    },
    metrics: {
      title: 'Performance Metrics',
      description: 'Real performance improvements backed by data',
      categories: {
        efficiency: 'Efficiency Improvement',
        quality: 'Quality Enhancement',
        automation: 'Automation Level',
        satisfaction: 'User Satisfaction'
      }
    }
  },
  faq: {
    title: 'FAQ',
    questions: {
      pricing: {
        question: 'How does billing work?',
        answer: 'We offer flexible billing plans, including pay-as-you-go and monthly packages. You can choose the appropriate plan based on your actual needs.'
      },
      howToStart: {
        question: 'How to get started?',
        answer: 'With a simple registration process, you can start using our services immediately. We also provide detailed documentation and technical support.'
      },
      platforms: {
        question: 'Which platforms are supported?',
        answer: 'We support all major operating systems and browsers, including but not limited to Windows, MacOS, Linux, etc.'
      }
    }
  },
  footer: {
    title: 'Lagent - Intelligent AI Agent Assistant',
    description: 'Make your work more efficient and easier',
    sections: {
      product: {
        title: 'Product',
        features: 'Features',
        pricing: 'Pricing',
        cases: 'Case Studies',
        api: 'API Reference'
      },
      resources: {
        title: 'Resources',
        docs: 'Documentation',
        tutorials: 'Tutorials',
        blog: 'Blog',
        support: 'Support'
      },
      company: {
        title: 'Company',
        about: 'About Us',
        careers: 'Careers',
        contact: 'Contact',
        partners: 'Partners'
      },
      legal: {
        title: 'Legal',
        privacy: 'Privacy Policy',
        terms: 'Terms of Service',
        cookies: 'Cookie Policy',
        security: 'Security'
      }
    },
    keywords: {
      neural: 'Neural Network',
      machine: 'Machine Learning',
      deep: 'Deep Learning',
      vision: 'Computer Vision',
      nlp: 'NLP',
      mining: 'Data Mining',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      analysis: 'Data Analysis',
      market: 'Marketing',
      content: 'Content Creation',
      creative: 'Creative Design',
      roi: 'ROI',
      insights: 'Data Insights',
      trend: 'Trend Analysis',
      metrics: 'Metrics',
      campaign: 'Campaign',
      work: 'Work Tasks'
    },
    copyright: ' 2025 Lagent. All rights reserved.'
  }
}
